import React, { Component } from 'react';
import { 
    Table, Modal, Button, Input, Upload, Radio, message, Tooltip, Icon,
} from 'antd';
import $, { xToken } from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';
import format from '../../../shared/format';

const RadioGroup = Radio.Group;

const Config = {
    apply: {
        title: '项目关闭申请',
    },
    approval: {
        title: '确认项目关闭',
    },
    view: {
        title: '查看项目数据',
    },
}

class ProjectClose extends Component {
    state = {
        data: [],
        record: {},
        loading: false,
        visible: false,
        params: {},
        fileList: [],
        type: 'apply',
        invCloseApplyId: '',
        invTips: '',
        customerTips: [],
        jdeCodesMarkRed: [],
    }

    show = (record = {}, type) => {
        this.setState({
            record,
            visible: true,
            type,
        }, () => {
            if (type === 'view'){
                this.queryInvCloseApplyRecord(record.invCloseApplyId);
            } else {
                this.loadData();
            }
        });
    }

    hide = () => {
        this.setState({
            data: [],
            record: {},
            visible: false,
            loading: false,
            params: {},
            fileList: [],
            invTips: '',
            customerTips: [],
            jdeCodesMarkRed: [],
        });
    }

    submit = () => {
        const { record, params, fileList, type, invCloseApplyId } = this.state;
        const {
            investigationId,
            invRemittanceCompletedInfo,
        } = record;
        const { 
            adjustDesc, 
            operationResult,
            noPassReason,
        } = params;
        const fromData = new FormData();
        
        if (type === 'apply') {
            fileList.map((file, index) => {
                fromData.append(`files[${index}]`, file)
            });
            fromData.append('curUserId', sessionStorage.userId);
            fromData.append('curRoleCode', sessionStorage.curRole);
            fromData.append('curEmployeeCode', sessionStorage.curEmployeeCode || '');
            fromData.append('investigationId', investigationId);
            if (adjustDesc) fromData.append('adjustDesc', adjustDesc);
            let url = API_URL.contract.addInvCloseApply;
            // 如果invCloseApplyId有值，说明是重新项目关闭申请的情况
            if (invCloseApplyId){
                fromData.append('invCloseApplyId', invCloseApplyId);
                url = API_URL.contract.updateInvCloseApply;
            }
            this.setState({ loading: true });
            const options = {
                method: 'post',
                url: API_URL.contract.checkInvCloseApplyInfo,
                data: {
                    investigationId,
                },
                dataType: 'json',
                doneResult: res => {
                    this.setState({ loading: false });
                    const { 
                        invTips, 
                        customerTips = [], 
                        invLevelCanApplyClose,
                        jdeCodes = [], 
                    } = res;
                    this.setState({ jdeCodesMarkRed: jdeCodes })
                    if (!invLevelCanApplyClose) {
                        message.error('项目合同额、开票、回款、收入金额未达到一致，无法发起项目关闭申请');
                    }
                    if (invTips) {
                        this.setState({ invTips });
                    }
                    if (!invLevelCanApplyClose || invTips) {
                        return
                    }
                    if (customerTips.length) {
                        Modal.confirm({
                            iconType: 'question-circle',
                            title: <div style={{ marginLeft: 42 }}>
                                    {customerTips.map(el => <div>
                                        JDE项目号
                                        <span 
                                            style={{ color: 'red' }}
                                        >
                                            {el.jdeCode}
                                        </span>
                                        {el.message}
                                    </div>
                                    )}
                                    请确认是否需要发起项目关闭申请?
                                </div>,
                            onOk: () => {
                                this.setState({ loading: true });
                                fetch(url, {
                                    method: 'post',
                                    body: fromData,
                                    headers: {
                                        'X-Requested-With': 'XMLHttpRequest',
                                        ...xToken,
                                    }
                                }).then(res => {
                                    if (res.ok) {
                                        return res.json();
                                    }
                                }).then(data => {
                                    if (data.error) {
                                        message.error(data.error);
                                        this.setState({ loading: false });
                                    } else {
                                        message.success(data.success);
                                        this.hide();
                                        this.props.loadData();
                                    }
                                }).catch(err => {
                                    message.error(err);
                                    this.setState({ loading: false });
                                });
                            },
                            width: 600,
                            okText: '确认,发起项目关闭申请',
                            cancelText: '取消,重新核对客户数据',
                        });
                    } else {
                        this.setState({ loading: true });
                        fetch(url, {
                            method: 'post',
                            body: fromData,
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                ...xToken,
                            }
                        }).then(res => {
                            if (res.ok) {
                                return res.json();
                            }
                        }).then(data => {
                            if (data.error) {
                                message.error(data.error);
                                this.setState({ loading: false });
                            } else {
                                message.success(data.success);
                                this.hide();
                                this.props.loadData();
                            }
                        }).catch(err => {
                            message.error(err);
                            this.setState({ loading: false });
                        });
                    }
                },
                errorResult: () => {
                    this.setState({ loading: false });
                }
            };
            $.sendRequest(options);

        } else {
            if (!operationResult) {
                return message.warning('请选择是否确认项目关闭')
            }
            if (operationResult === 'APPROVE_NOT_PASS' && !noPassReason) {
                return message.warning('请输入拒绝原因')
            }
            let url = '';
            if (invRemittanceCompletedInfo == 'TO_BE_CHARGE_USER_CONFIRM') {
                url = API_URL.contract.invChargeUserAudit;
            } else {
                url = API_URL.contract.finAuditCloseApply;
            }
            this.setState({ loading: true });
            const options = {
                method: 'post',
                url,
                data: {
                    investigationId,
                    operationResult,
                    noPassReason,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                    this.hide();
                    this.props.loadData();
                }
            };
            $.sendRequest(options);
        }
    }

    loadData = () => {
        const { record: { investigationId }, type } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url: API_URL.contract.queryInvCloseApplyInfo,
            data: {
                investigationId,
            },
            dataType: 'json',
            doneResult: res => {
                const { 
                    invCloseApply: {invCloseApplyId, remark}, 
                    list, 
                    fileList,
                    // invLevelCanApplyClose,
                    // invTips,
                    // customerTips,
                } = res;
                const { params } = this.state;
                params.adjustDesc = remark ? remark : undefined;
                this.setState({
                    data: list,
                    invCloseApplyId,
                    fileList: type === 'apply' ? [] : fileList,
                    params,
                    loading: false,
                    // invLevelCanApplyClose,
                    // invTips,
                    // customerTips,
                });
            }
        };
        $.sendRequest(options);
    }

    queryInvCloseApplyRecord = (invCloseApplyId) => {
        this.setState({ loading: true });
        const options = {
            method: 'post',
            url : API_URL.contract.queryInvCloseApplyRecord ,
            data: {
                invCloseApplyId,
            },
            dataType: 'json',
            doneResult: res => {
                const { 
                    invCloseApply: { remark }, 
                    list, 
                    fileList,
                } = res;
                const { params } = this.state;
                params.adjustDesc = remark ? remark : undefined;
                this.setState({
                    data: list,
                    fileList,
                    params,
                    loading: false,
                });
            }
        };
        $.sendRequest(options);
    }

    handleFileChange = ({ file, fileList }) => {
        if (file.status == "done") {
            if (file.response.error) {
                message.error(file.response.error);
                file.status = 'removed';
                const fileData = [...this.state.fileList];
                const index = fileData.indexOf(file);
                fileList.splice(index, 1);
            } else if (file.response.success) {
                message.success('上传附件成功');
            }
        }
        this.setState({ fileList });
    }

    getColumns = () =>{
        const { curRole } = sessionStorage;
        const { type } = this.state;
        const columns = [
            {
                title: '客户名称',
                dataIndex: 'customerCompanyName',
                key: 'customerCompanyName',
                width: 120,
                render: (text, record) => {
                    const { customerCompanyName, sortNum } = record;
                    return sortNum == 1 ? '-' : <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{text}</span>
                }
            },
            {
                title: '客户代号',
                dataIndex: 'customerCompanyCode',
                key: 'customerCompanyCode',
                width: 70,
                render: (text, record) => {
                    const { sortNum } = record;
                    return sortNum == 1 ? '-' : text
                }
            },
            {
                title: 'JDE项目号',
                dataIndex: 'jdeCode',
                key: 'jdeCode',
                width: 110,
                render: (text, record) => {
                    const { sortNum, jdeCode, customerCompanyCode } = record;
                    const { jdeCodesMarkRed } = this.state;
                    const markRed = jdeCodesMarkRed.some(el => (el.jdeCode == jdeCode && el.customerCompanyCode == customerCompanyCode ));
                    return sortNum == 1 ? '-' : <span style={{ color: markRed ? 'red' : undefined }}>{text}</span>
                }
            }
        ];
        if (curRole === 'FIN' && (type === 'view' || type === 'approval')) {
            columns.push({
                title: 'rebate费',
                dataIndex: 'rebateAmount',
                key: 'rebateAmount',
                width: 90,
                render: (text, record) => {
                    const { sortNum } = record;
                    return sortNum == 1 ? '-' : text
                }
            }, {
                title: 'AR',
                dataIndex: 'arAmount',
                key: 'arAmount',
                width: 90,
                render: (text, record) => {
                    const { sortNum } = record;
                    return sortNum == 1 ? '-' : text
                }
            })
        }
        columns.push(
        {
            title: '币种',
            dataIndex: 'currencyShow',
            key: 'currencyShow',
            width: 60,
            render: (text, record) => {
                const { sortNum } = record;
                return sortNum == 1 ? '-' : text
            }
        },
        {
            title: '服务费',
            children: [{
                title: '合同额含税/原币（明标金额）',
                dataIndex: 'serviceContractAmountWithTaxInitial',
                key: 'serviceContractAmountWithTaxInitial',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }, {
                title: '合同额含税/原币（非明标金额）',
                dataIndex: 'serviceContractAmountWithTaxInitialNoSpecifies',
                key: 'serviceContractAmountWithTaxInitialNoSpecifies',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }, {
                title: '开票含税金额/原币',
                dataIndex: 'serviceInvoiceAmountWithTaxInitial',
                key: 'serviceInvoiceAmountWithTaxInitial',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }, {
                title: '回款含税金额/原币',
                dataIndex: 'serviceBackAmountWithTaxInitial',
                key: 'serviceBackAmountWithTaxInitial',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }, {
                title: (
                    <span>
                        累计收入含税/原币
                        <Tooltip overlayStyle={{ width: 200 }} placement="top" title={'收入报表下该项目该客户的科目账包含“1021或2002或0102”的“原币金额”合计值*（1+发票税率）'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'serviceCumulativeAmountWithTaxInitial',
                key: 'serviceCumulativeAmountWithTaxInitial',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }],
        },
        {
            title: 'PT费',
            children: [{
                title: '合同额含税/原币（明标金额）',
                dataIndex: 'ptContractAmountWithTaxInitial',
                key: 'ptContractAmountWithTaxInitial',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }, {
                title: '合同额含税/原币（非明标金额）',
                dataIndex: 'ptContractAmountWithTaxInitialNoSpecifies',
                key: 'ptContractAmountWithTaxInitialNoSpecifies',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }, {
                title: '开票含税金额/原币',
                dataIndex: 'ptInvoiceAmountWithTaxInitial',
                key: 'ptInvoiceAmountWithTaxInitial',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }, {
                title: '回款含税金额/原币',
                dataIndex: 'ptBackAmountWithTaxInitial',
                key: 'ptBackAmountWithTaxInitial',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }, {
                title: (
                    <span>
                        累计收入含税/原币
                        <Tooltip overlayStyle={{ width: 200 }} placement="top" title={'收入报表下该项目该客户的的科目账包含“1011或2011”的“原币金额”合计值*（1+发票税率）'}>
                            <a><Icon style={{  marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'ptCumulativeAmountWithTaxInitial',
                key: 'ptCumulativeAmountWithTaxInitial',
                width: 90,
                render: (text, record) => {
                    const { customerCompanyName } = record;
                    return <span style={{ color: customerCompanyName === '合计' ?  '#fda66d' : undefined }}>{format('money', text)}</span>
                }
            }],
        }
        )
        return columns
    } 

    handleChange = (value, key) => {
        const { params } = this.state;
        params[key] = value;
        this.setState({
            params,
        })
    }

    beforeUpload = (file) => {
        const { invCloseApplyId } = this.state;
        if (invCloseApplyId) {
            const { fileList = [] } = this.state;
            const isLt30M = file.size / 1024 / 1024 <=30;
            if (fileList.length >= 10) {
                message.warning('最多上传10个附件');
                return false;
            }
            if (!isLt30M) {
                message.warning('文件大小不能超过30M');
                return false;
            }
        } else { 
            this.setState({
                fileList: [
                    ...this.state.fileList,
                    file,
                ]
            })
            return false
        }
    }

    handleRemove = (file, message = true) => {
        const { invCloseApplyId } = this.state;
        if (invCloseApplyId) {
            const options = {
                method: 'POST',
                url: API_URL.contract.deleteOssFile,
                data: {
                    id: file.response.id,
                },
                dataType: 'json',
                doneResult: res => {
                    if (res.error) {
                        message && message.error(res.error);
                    } else {
                        message && message.success(res.success);
                    }
                }
            };
            $.sendRequest(options);
        } else {
            const { fileList } = this.state;
            const index = fileList.indexOf(file);
            const newFileList = fileList.slice();
            newFileList.splice(index, 1);
            this.setState({ fileList: newFileList });
        }
    }

    downLoadFile = (e, id) => {
        const url = API_URL.contract.downloadOssFile;
        ExportUtil.export({ id }, null, url);
    }
    render() {
        const {
            visible,
            loading,
            data,
            record = {},
            fileList,
            type,
            params,
            invCloseApplyId,
            invTips,
        } = this.state;
        const { investigationName, mainInvestigationJdeContractCode, invRemittanceCompletedInfo } = record;
        const { operationResult, adjustDesc, noPassReason } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        return (
            <Modal
                title={Config[type].title}
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="1300px"
                bodyStyle={{ maxHeight: 600 }}
                footer={type === 'view' ?
                    <Button key="cancel" onClick={this.hide}>关闭</Button> :
                    [
                        <Button key="cancel" onClick={this.hide}>取消</Button>,
                        <Button key="ok" type="primary" onClick={this.submit} loading={loading}>确定</Button>,
                    ]
                }
            >
                <div className="cont-cont contract-record" style={{ margin: 20 }}>
                    <div style={{ marginBottom: 16 }}>
                        项目简称：{investigationName}&nbsp;&nbsp;&nbsp;&nbsp;JDE主项目号：{mainInvestigationJdeContractCode}
                    </div>
                    <div>
                        <Table
                            columns={this.getColumns()}
                            dataSource={data}
                            rowKey={record => record.sortNum}
                            pagination={false}
                            loading={loading}
                            scroll={{ x: 500 }}
                        />
                        <div style={{ display: 'flex', alignItems: 'center', width: 600, margin: '18px 0px' }}>
                            <div style={{ width: '30%', textAlign: 'right' }}>备注：</div>
                            <div style={{ width: '70%' }}>
                                {
                                    type === 'apply' ? <Input
                                        placeholder="请输入"
                                        style={{ width: 350 }}
                                        value={adjustDesc}
                                        onChange={e => this.handleChange(e.target.value, 'adjustDesc')}
                                    /> : adjustDesc
                                }
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', width: 600, marginBottom: 20 }}>
                            <div style={{ width: '30%', textAlign: 'right' }}>其他支持性文件：</div>
                            <div style={{ width: '70%' }}>
                                {
                                    type === 'apply' ?
                                        <Upload
                                            action={API_URL.contract.uploadOssFile}
                                            data={{
                                                relateId: invCloseApplyId,
                                                uploadType: 'INV_CLOSE_APPLY',
                                                curUserId: sessionStorage.userId,
                                                curEmployeeCode: sessionStorage.curEmployeeCode || '',
                                            }}
                                            fileList={fileList}
                                            beforeUpload={this.beforeUpload}
                                            onChange={this.handleFileChange}
                                            onRemove={this.handleRemove}
                                            headers={xToken}
                                        >
                                            <Button style={{ width: 80 }}>选择文件</Button>
                                        </Upload>
                                        :
                                        fileList.map(i => <a onClick={e => this.downLoadFile(e, i.id)}>{i.fileName}<br /></a>)
                                }
                            </div>
                        </div>
                        {
                            type === 'approval' &&
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: 600,
                                marginBottom: 20
                            }}
                            >
                                <div style={{ width: '30%', textAlign: 'right' }}>{asterisk}{invRemittanceCompletedInfo == 'TO_BE_CHARGE_USER_CONFIRM' ? '负责人是否确认项目关闭' : 'FIN是否确认项目关闭'}：</div>
                                <div style={{ width: '70%' }}>
                                    <RadioGroup
                                        value={operationResult}
                                        onChange={e => this.handleChange(e.target.value, 'operationResult')}
                                    >
                                        <Radio value={'APPROVE_PASS'}>确认</Radio>
                                        <Radio style={{ marginLeft: '80px' }} value={'APPROVE_NOT_PASS'}>拒绝</Radio>
                                    </RadioGroup>
                                </div>
                            </div>
                        }
                        {
                            operationResult === 'APPROVE_NOT_PASS' &&
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: 600,
                                marginBottom: 20
                            }}
                            >
                                <div style={{ width: '30%', textAlign: 'right' }}>{asterisk}拒绝原因：</div>
                                <div style={{ width: '70%' }}>
                                    <Input
                                        placeholder="请输入"
                                        style={{ width: 350 }}
                                        value={noPassReason}
                                        onChange={e => this.handleChange(e.target.value, 'noPassReason')}
                                    />
                                </div>
                            </div>
                        }
                        {
                            type === 'apply' && <div style={{ color: '#fdb74f', margin: '0px 0px 12px 180px' }}>
                                请上传和客户确认最终结算金额的邮件或其他支持性文件以备查看
                            </div>
                        }
                        {
                            (type === 'apply' && invTips) && <div style={{ 
                                color: 'red', 
                                whiteSpace: 'normal',
                                margin: '30px 0px 30px 50px',
                                width: '94%',
                            }}>
                                {invTips}
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ProjectClose



// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/ProjectClose.js